import React from 'react';
import infoIcon from 'assets/svg/information-purple.svg';
import css from './bottom-info-bar.scss';
export const BottomInfoBar = ({
  text
}) => /*#__PURE__*/React.createElement("div", {
  className: css.root
}, /*#__PURE__*/React.createElement("img", {
  src: infoIcon,
  className: css.icon
}), /*#__PURE__*/React.createElement("div", {
  className: css.text
}, text));